<template>
	<div class="container main-swiper-container">
		<swiper ref="mySwiper" :options="swiperOption" class="main-swiper pdx-4">
      <swiper-slide
          v-for="(lesson, index) in lessonsList"
          :key="index"
          class="swiper-slide">
        <div :class="lesson.progressionId === currentProgressionId ? 'current':''" class="mdc-card cursor-pointer" tabindex="0" @click="moveNextLessons(lesson)" @keypress="moveNextLessons(lesson)"  >
          <div class="mdc-card__primary-action1" tabindex="0">
            <div v-if="thumbnailVideo" class=" position-relative z-99">
              <img v-if="thumbnailVideo" :alt="lesson.name" :src="thumbnailVideo">
              <button v-if="lesson.progressionId === currentProgressionId" class="h-28  mdc-button position-absolute bg-mainBtn t-color-mainBtnText b-radius24 mgt-16 mgl-16 mgr-16" disabled style="top:0;">
                <div class="mdc-button__ripple"></div>
                <img alt="" class="mgr-6 w-16 h-16" src="/img/play.svg">
                <span class="mdc-button__label t-helper font-r">{{$t('3331')}}</span>
              </button>
            </div>
            <div v-else class=" position-relative z-99">
              <button v-if="lesson.progressionId === currentProgressionId" class="h-28 mdc-button bg-mainBtn t-color-mainBtnText b-radius4 mgt-16 mgl-16 mgr-16" disabled>
                <div class="mdc-button__ripple"></div>
                <img alt="" class="mgr-6 w-16 h-16" src="/img/play.svg">
                <span class="mdc-button__label t-helper font-r">{{$t('3331')}}</span>
              </button>
            </div>
            <div class="mgt-24">
              <div class="t-headline7 pdl-24 pdr-16 t-color-headlineBlack font-m t-line-h-28 ">
                {{lesson.name}}
              </div>
              <div v-if="isLCMS(lesson) && lesson.contents.lcms.type.translate === 'code.fileContentsType.interactiveHtml'" class="t-body6 pdl-24 pdr-16 t-color-bodyGrayA font-r mgt-16 t-line-h-22">{{ lesson.status.value === 'OPENED' && lesson.rate < 100?$t('3166'):lesson.status.value === 'WAITING' && lesson.rate < 100?$t('3166'):$t('146')}} </div>
              <div v-else-if="isLCMS(lesson) && lesson.contents.lcms.type.translate === 'code.fileContentsType.cegos'" class="t-body6 pdl-24 pdr-16 t-color-bodyGrayA font-r mgt-16 t-line-h-22">{{ lesson.status.value === 'OPENED' && lesson.rate < 100?$t('4827'):lesson.status.value === 'WAITING' && lesson.rate < 100?$t('4827'):$t('146')}} </div>
              <div v-else-if="isLCMS(lesson) && lesson.contents.lcms.type.translate === 'code.fileContentsType.liveSession'" class="t-body6 pdl-24 pdr-16 t-color-bodyGrayA font-r mgt-16 t-line-h-22">{{ lesson.status.value === 'OPENED' && lesson.rate < 100?$t('3305'):lesson.status.value === 'WAITING' && lesson.rate < 100?$t('3305'):$t('146')}} </div>
              <div v-else-if="isLCMS(lesson) && lesson.contents.lcms.type.translate === 'code.fileContentsType.video'" class="t-body6 pdl-24 pdr-16 t-color-bodyGrayA font-r mgt-16 t-line-h-22">{{ lesson.status.value === 'OPENED' && lesson.rate < 100?$t('100'):lesson.status.value === 'WAITING' && lesson.rate < 100?$t('100'):$t('146')}} </div>
              <div v-else-if="isLCMS(lesson) && lesson.contents.lcms.type.translate === 'code.fileContentsType.slide'" class="t-body6 pdl-24 pdr-16 t-color-bodyGrayA font-r mgt-16 t-line-h-22">{{ lesson.status.value === 'OPENED' && lesson.rate < 100?$t('101'):lesson.status.value === 'WAITING' && lesson.rate < 100?$t('101'):$t('146')}} </div>
              <div v-else-if="isLCMS(lesson) && lesson.contents.lcms.type.translate === 'code.fileContentsType.pdf'" class="t-body6 pdl-24 pdr-16 t-color-bodyGrayA font-r mgt-16 t-line-h-22">{{ lesson.status.value === 'OPENED' && lesson.rate < 100?$t('102'):lesson.status.value === 'WAITING' && lesson.rate < 100?$t('102'):$t('146')}} </div>
              <div v-else-if="isLCMS(lesson) && lesson.contents.lcms.type.translate === 'code.fileContentsType.html'" class="t-body6 pdl-24 pdr-16 t-color-bodyGrayA font-r mgt-16 t-line-h-22">{{ lesson.status.value === 'OPENED' && lesson.rate < 100?$t('103'):lesson.status.value === 'WAITING' && lesson.rate < 100?$t('103'):$t('146')}} </div>
              <div v-else-if="lesson.contents.exam !== null" class="t-body6 pdl-24 pdr-16 t-color-bodyGrayA font-r mgt-16 t-line-h-22">{{ lesson.status.value === 'OPENED' && lesson.rate < 100?$t('148'):lesson.status.value === 'WAITING' && lesson.rate < 100?$t('148'):$t('146')}} </div>
            </div>
            <div class="mgt-2 pdl-24 mgb-24 h-25">
              <span class="font-r t-color-headlineBlack t-body6 pdr-4 t-line-h-22">by</span>
              <span class="font-r t-color-headlineBlack t-body6 t-line-h-22">{{teacher ?$t('3437',{first: teacher.first, last: teacher.last}):''}}</span>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
	</div>
</template>

<script>
/**
 * 학습창 레슨 목록
 *
 * @author minkyoung.park@emcast.com
 * @author
 * @since 2019.08
 */
import {swiper, swiperSlide} from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import microLearnApi from "@/api/microLearnApi.js";
// Components/Mixin/Extend/API 선언
export default {
	props: ['lessonsList', 'thumbnailVideo', 'currentProgressionId','teacherName', 'teacher','isQuestionAns'],

	components: {
		swiper,
		swiperSlide,
	},

	data() {
		return{
			swiperOption: {
				spaceBetween: 20,
				observer: true,
				observeParents: true,
				slidesPerView: "auto",
					translate: 0,
					autoHeight: false,
			},
			liveProgressRate: 0,
      statusTab:null
		}
	},

	computed: {
		// swiper define
		swiper() {
			return this.$refs.mySwiper.swiper;
		},
	},

	mounted() {
		this.mySwiperList = this.$refs.mySwiper.swiper;
    this.mySwiperList.on('slideChange', () => {
      let activeIndex = this.mySwiperList.activeIndex;
      if(this.isQuestionAns && this.mySwiperList.activeIndex > 1 && this.mySwiperList.activeIndex < 3) {
        document.querySelector('.lession-first-slide').style.marginRight = -(window.innerWidth / 4)+`px`;
      } else if(this.isQuestionAns && this.mySwiperList.activeIndex > 2) {
        document.querySelector('.lession-first-slide').style.marginRight = -(window.innerWidth / 3) - 10-460+`px`;
      } else{
        document.querySelector('.lession-first-slide').style.marginRight = "20px";
      }
    })
		this.statusTab = this.$route.query.status;
	},

	methods: {
    isLCMS(lesson) {
      return !!(lesson.contents && lesson.contents.lcms && lesson.contents.lcms.type);
    },

		moveNextLessons(lesson) {
			if (lesson.status.value === 'OPENED' ) {
				if (lesson.contentsType.value === "EXAM") {
					let query = this.$route.query;
					query.type='formal-evolution'
					this.$router.push({
						name: "MicroExamIntro",
						params: {
						learnId: this.$route.params.learnId,
						examineeId: lesson.examineeId,
						},
						query: query,
					});
        } else if(lesson.contentsType.value === 'LIVE_SESSION'){
					let params = {
						learnId: this.$route.params.learnId,
						progressionId: lesson.progressionId
					}
					microLearnApi.learnLessonContents(params).then((response) => {
					let liveSessionTrueFalse = response.data.data.liveSession.canParticipate
						if(liveSessionTrueFalse === false) {
							this.$alert({
								title: this.$t("3434"), // 학습을 중단한 강의입니다.
								content: this.$t("3435"), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
								accept: this.$t("3436"), // 확인
							})
							.then(() => {})
							.catch(() => {});
						} else {
							let responseData = response.data.data
							let liveSessionData = responseData
							this.zoomMetting(lesson,liveSessionData)
						}
					}).catch((err) => {})
				} else {
						if(this.statusTab === 'COMPLETION' && this.todayDate>this.basicData.periodLearning.end && this.todayDate>this.basicData.periodReview.start) {
							this.$alert({
								title: this.$t("1944"), // 학습을 중단한 강의입니다.
								content: this.$t("1945"), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
								accept: this.$t("1946"), // 확인
							})
							.then(() => {})
							.catch(() => {});
						} else {
							this.$router.push({
								name: "MicroDegreeLessonView",
								params: {
								learnId: this.$route.params.learnId,
								lessonId: lesson.id,
								progressionId: lesson.progressionId,
								},
								query: this.$route.query,
							});
						}
					}
      } else if(this.statusTab === "WAITING"){
					if(this.todayDate<this.basicData.periodLearning.start) {
						this.$alert({
							title: this.$t("3431"), // 학습을 중단한 강의입니다.
							content: this.$t("3432"), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
							accept: this.$t("3433"), // 확인
						}).then(() => {})
							.catch(() => {});
					}
			} else {
				this.$alert({
					content: '<div id="slidePopup" >'+this.$t('1885')+"<br/>"+this.$t('1886')+'</div>',
					accept:  this.$t('1887'),
				}).then(() => {})
			}
		},

		zoomMetting(lesson,liveSessionData,target='_blank', rel="noopener noreferrer"){
      window.open(liveSessionData.liveSession.url, target,rel);
      this.updateProgress(lesson);
    },

    updateProgress(lesson) {
      let params = {
        total: 0,
        current: 0,
        learnId: this.$route.params.learnId,
        progressionId: lesson.progressionId
      }
      let responseData = null
      microLearnApi.learnLessonProgression(params).then((response) => {
        responseData = response.data.data
        this.liveProgressRate = responseData.rate
        this.$router.go(this.$router.currentRoute)
      }).catch((err) => {})
    },
	}
}
</script>

<style scoped>
.mdc-dialog__content {
		padding: 24px  !important;
}

.mdc-dialog-scroll-lock .mdc-dialog__container .mdc-dialog__surface {
	max-width: 280px !important;
	width:280px !important;
}

 .mdc-card.current::after {
    border-radius: 4px;
    border-radius: var(--mdc-shape-medium, 4px);
    position: absolute;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    border: 1px solid transparent;
    border-radius: inherit;
    content: "";
    pointer-events: none;
    pointer-events: none;
    background: var(--BlackPressed);
}

html[dir="rtl"] .mdc-card.current::after {
    right: 0;
}

.slide-slider .gallery-top .swiper-container-horizontal .swiper-slide {
  height: unset !important;
}
</style>
